import { useLanguage } from "@/lib/LanguageContext";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const PHONE = "(781) 475-6126";
const EMAIL = "sousaedyy85@hotmail.com";

export const Footer = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer-section" className="relative border-t border-white/5" style={{ background: '#05121d' }}>
      <div className="absolute inset-0 noise-overlay" />

      <div className="relative z-10 container mx-auto px-4 md:px-8 max-w-7xl py-16 md:py-24">
        {/* Main footer */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-3">
              <img
                src="https://customer-assets.emergentagent.com/job_boston-auto-service/artifacts/cfvpdtrh_WhatsApp%20Image%202026-05-11%20at%201.21.44%20PM.jpeg"
                alt="SousA Logo"
                className="w-10 h-10 object-contain"
              />
              <h2 className="font-heading text-3xl font-bold tracking-wider text-white">
                SOUSA
              </h2>
            </div>
            <p className="font-body text-xs tracking-[0.2em] uppercase text-slate-500 mb-6">Auto Service Inc</p>
            <p className="font-body text-sm text-slate-400 leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-sm tracking-[0.2em] uppercase text-gold mb-6">{t.footer.quickLinks}</h3>
            <nav className="space-y-3">
              {["home", "services", "about", "area", "reviews", "contact"].map((section) => (
                <button
                  key={section}
                  onClick={() => scrollToSection(section)}
                  className="block text-sm text-slate-400 hover:text-teal transition-colors font-body"
                >
                  {t.nav[section]}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading text-sm tracking-[0.2em] uppercase text-gold mb-6">{t.footer.contactInfo}</h3>
            <div className="space-y-4 font-body text-sm">
              <a href="tel:+17814756126" className="flex items-center gap-3 text-slate-400 hover:text-teal transition-colors">
                <Phone className="w-4 h-4 text-teal flex-shrink-0" strokeWidth={1.5} />
                {PHONE}
              </a>
              <a href={`mailto:${EMAIL}`} className="flex items-center gap-3 text-slate-400 hover:text-teal transition-colors">
                <Mail className="w-4 h-4 text-teal flex-shrink-0" strokeWidth={1.5} />
                {EMAIL}
              </a>
              <a href="https://www.google.com/maps/search/?api=1&query=216+Main+St%2C+North+Reading%2C+MA" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-slate-400 hover:text-teal transition-colors">
                <MapPin className="w-4 h-4 text-teal flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                216 Main St, North Reading, MA
              </a>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h3 className="font-heading text-sm tracking-[0.2em] uppercase text-gold mb-6">{t.footer.hours}</h3>
            <div className="space-y-3 font-body text-sm">
              <div className="flex items-center gap-2 text-slate-400">
                <Clock className="w-4 h-4 text-teal flex-shrink-0" strokeWidth={1.5} />
                <span>{t.about.monFri}: {t.about.monFriTime}</span>
              </div>
              <div className="flex items-center gap-2 text-slate-400">
                <Clock className="w-4 h-4 text-teal flex-shrink-0" strokeWidth={1.5} />
                <span>{t.about.sat}: {t.about.satTime}</span>
              </div>
              <div className="flex items-center gap-2 text-slate-400">
                <Clock className="w-4 h-4 text-red-400 flex-shrink-0" strokeWidth={1.5} />
                <span>{t.about.sun}: {t.about.sunTime}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-slate-500">
            &copy; {new Date().getFullYear()} SousA Auto Service Inc. {t.footer.rights}
          </p>
          <p className="font-body text-xs text-slate-600">
            <a href="https://www.google.com/maps/search/?api=1&query=216+Main+St%2C+North+Reading%2C+MA" target="_blank" rel="noopener noreferrer" className="hover:text-teal transition-colors">
              216 Main St, North Reading, MA 01864
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
